/* Ryedical — /pages/whats-in-each-tablespoon interactions
   1. Scroll-spy: highlight sidebar link whose section is currently in view
   2. Mobile accordion: tap to expand/collapse (multiple open allowed)
*/
(function () {
  'use strict';

  function initScrollSpy(root) {
    var sidebar = (root || document).querySelector('.ry-wiet-sidebar');
    var sections = (root || document).querySelectorAll('.ry-wiet-compound');
    if (!sidebar || !sections.length || !('IntersectionObserver' in window)) return;

    var linksByHref = {};
    sidebar.querySelectorAll('.ry-wiet-sidebar__link').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href && href.indexOf('#') === 0) linksByHref[href.slice(1)] = a;
    });

    function setActive(id) {
      Object.keys(linksByHref).forEach(function (k) {
        linksByHref[k].classList.toggle('is-active', k === id);
      });
    }

    var visible = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        visible[e.target.id] = e.isIntersecting ? e.intersectionRatio : 0;
      });
      var topId = null;
      var topRatio = 0;
      Object.keys(visible).forEach(function (id) {
        if (visible[id] > topRatio) { topRatio = visible[id]; topId = id; }
      });
      if (topId) setActive(topId);
    }, {
      rootMargin: '-96px 0px -55% 0px',
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    sections.forEach(function (s) { observer.observe(s); });

    if (sections[0] && sections[0].id) setActive(sections[0].id);
  }

  function initAccordion(root) {
    var items = (root || document).querySelectorAll('.ry-wiet-acc-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.ry-wiet-acc-q');
      var icon = item.querySelector('.ry-wiet-acc-icon');
      if (!btn || btn.dataset.ryBound === '1') return;
      btn.dataset.ryBound = '1';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (icon) icon.textContent = open ? '−' : '+';
      });
    });
  }

  function init() {
    initScrollSpy(document);
    initAccordion(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initScrollSpy(e.target);
    initAccordion(e.target);
  });
})();
